import { useCallback, useEffect, useState } from 'react';
import { Inbox, Lock, Sparkles, Loader2 } from 'lucide-react';
import api from '../services/api';

const unwrap = (v: any) => v?.data?.data ?? v?.data ?? v;

export default function SupplierLeads() {
  const [state, setState] = useState<'loading' | 'unclaimed' | 'ready'>('loading');
  const [fullAccess, setFullAccess] = useState(false);
  const [leads, setLeads] = useState<any[]>([]);

  const load = useCallback(async () => {
    try {
      const r = await api.get('/suppliers/me/leads');
      const d = unwrap(r);
      setLeads(d?.leads || []);
      setFullAccess(!!d?.full_access);
      setState('ready');
    } catch (x: any) {
      if (x.response?.status === 403) setState('unclaimed');
      else setState('unclaimed');
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (state === 'loading') return (
    <div className="flex items-center justify-center p-16 text-slate-500 dark:text-slate-400"><Loader2 className="mr-2 animate-spin" size={18} /> Cargando…</div>
  );

  if (state === 'unclaimed') return (
    <div className="mx-auto max-w-xl p-6 text-center">
      <Inbox className="mx-auto mb-4 h-12 w-12 text-[#36CCD8]" />
      <h1 className="text-2xl font-bold text-slate-900 dark:text-[var(--v-text-primary)]">Mis Leads</h1>
      <p className="mt-3 text-slate-600 dark:text-slate-300">Aún no tienes un negocio reclamado. Ve al directorio de proveedores y reclama tu negocio para empezar a recibir clientes.</p>
      <a href="/suppliers" className="mt-5 inline-block rounded-xl bg-[#36CCD8] px-5 py-2.5 font-semibold text-slate-900">Ir al directorio</a>
    </div>
  );

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-5xl mx-auto">
      <h1 className="text-2xl font-bold text-slate-900 dark:text-[var(--v-text-primary)]">Mis Leads</h1>
      {fullAccess ? (
        <div className="mt-4 flex items-center gap-2 rounded-xl border border-emerald-300 dark:border-emerald-700 bg-emerald-50 dark:bg-emerald-900/30 p-4 text-sm text-emerald-800 dark:text-emerald-200">
          <Sparkles size={18} /> Acceso completo gratis por tus primeros 3 meses desde tu primer cliente.
        </div>
      ) : (
        <div className="mt-4 flex items-center gap-2 rounded-xl border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/30 p-4 text-sm text-amber-800 dark:text-amber-200">
          <Lock size={18} /> Tu período gratis terminó. Crea tu cuenta Pro para ver los datos de contacto de nuevos clientes.
        </div>
      )}
      <div className="mt-6 rounded-2xl border border-slate-200 dark:border-[var(--v-surface-3)] bg-white dark:bg-[var(--v-surface-1)]">
        {leads.length === 0 ? (
          <p className="p-6 text-sm text-slate-500 dark:text-slate-400">Aún no tienes leads. Cuando un residente solicite tus servicios, aparecerá aquí.</p>
        ) : (
          <div className="divide-y divide-slate-100 dark:divide-[var(--v-surface-3)]">
            {leads.map(l => (
              <div key={l.id} className="p-4 text-sm">
                <div className="flex items-center justify-between">
                  <p className="font-medium text-slate-900 dark:text-white">Solicitud de servicio</p>
                  <span className="text-xs text-slate-500 dark:text-slate-400">{new Date(l.created_at).toLocaleString('es')}</span>
                </div>
                {l.teaser_only ? (
                  <p className="mt-1 flex items-center gap-1 text-slate-500 dark:text-slate-400"><Lock size={14} /> Un residente está interesado en tus servicios. <span className="font-medium text-amber-600 dark:text-amber-400">Datos de contacto disponibles con Pro.</span></p>
                ) : (
                  <p className="mt-1 text-slate-600 dark:text-slate-300">Contacto: {l.resident_email || '—'}{l.resident_contact ? ` · ${l.resident_contact}` : ''}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
